<template>

    <MenuHealthCompact/>

    <div class="px-6 surface-overlay relative">
        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Forms</h3>

                    <div class="field">
                        <label for="clientIntakeForm">Client Intake Form</label>
                        <InputText id="clientIntakeForm" type="text" :disabled="true" v-model.trim="clientIntakeForm"/>
                    </div>

                    <br>
                    <div class="field">
                        <label for="bookingForm">Booking Form</label>
                        <InputText id="bookingForm" type="text" :disabled="true" v-model.trim="bookingForm"/>
                    </div>

                    <br>
                    <h3>New Forms</h3>

                    Please send your form to info@kitrin.com, and the team will complete the design of the form and load it to your
                    account within three (3) working days.

                </div>
            </div>
        </div>
    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import CompanyService from "@/service/CompanyService";

export default {
    components: {
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            // Attempt to get user data
            const userData = await UserService.getUser(this.userStore.user.id);
            this.profile = userData.data;
            console.log("[PhoneCalls][mounted] Data = ", userData);
            console.log("[PhoneCalls][mounted] this.profile = ", this.profile);
        } catch (e) {
            console.error("[PhoneCalls][mounted] Error fetching user data = ", e);
            this.userStore.clearUser();
            this.$router.push('login');
            return; // Exit early if getUser fails
        }

        try {
            const [userConfigData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id)
            ]);

            this.userConfiguration = userConfigData.data;
            console.log("[PhoneCalls][mounted] userConfigData.data = ", userConfigData.data);
        } catch (e) {
            console.error("[PhoneCalls][mounted] Could not find user config for user = ", this.userStore.user.id);
        }

        try {
            const [companyConfigData] = await Promise.all([
                CompanyService.getCompanyConfiguration(this.profile.companyId)
            ]);

            this.companyConfiguration = companyConfigData.data;
            console.log("[PhoneCalls][mounted] companyConfigData.data = ", companyConfigData.data);

            this.clientIntakeForm = "https://app.isoevolve.com/#/sa/clientintake?reference=" + this.profile.companyId;
            this.bookingForm = "https://app.isoevolve.com/#/booking?reference=" + this.profile.companyId;

        } catch (e) {
            console.error("[PhoneCalls][mounted] Error fetching additional data = ", e);
        }

        console.log("[PhoneCalls][mounted] this.userConfiguration = ", this.userConfiguration);
        console.log("[PhoneCalls][mounted] this.companyConfiguration = ", this.companyConfiguration);
    },
    data() {

        return {
            profile: {},
            companyConfiguration: {},
            clientIntakeForm: null,
            bookingForm: null
        }
    },
    methods: {
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
